<template>
  <div class="steps-data-view" v-loading="loading">
    <div class="case-each-step">
      <div class="emr-orders-status">
        <div class="step-inner-navbar">
          <ul>
            <li>
              <div class="title-with-icon">
                <h3 class="title">Raw Data</h3>
              </div>
            </li>
          </ul>
        </div>
        <code>
          {{ this.orderData.source_content }}
        </code>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  async mounted() {
    await this.fetchConfigData();
  },
  computed: {
    ...mapGetters("emrOrders", ["getSingleEMROrderViewConfig"]),
  },
  data() {
    return {
      loading: false,
      orderData: {},
      viewData: [],
    };
  },
  methods: {
    async fetchConfigData() {
      this.loading = true;
      if (this.$route.params.order_id) {
        await this.$store.dispatch("emrOrders/fetchSingleEMROrderViewConfig", {
          order_id: this.$route.params.order_id,
        });
        this.orderData = this.getSingleEMROrderViewConfig;
        this.viewData = [this.orderData.source_data];
      }
      this.loading = false;
    },
  },
};
</script>
